function extractFilename(dispositionHeader) {
  if (!dispositionHeader) {
    return '';
  }

  const utfMatch = dispositionHeader.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch && utfMatch[1]) {
    return decodeURIComponent(utfMatch[1]);
  }

  const asciiMatch = dispositionHeader.match(/filename="?([^";]+)"?/i);
  return asciiMatch && asciiMatch[1] ? asciiMatch[1] : '';
}

export async function downloadReport(url, fallbackFilename = 'report.xlsx') {
  const response = await fetch(url);
  const contentType = response.headers.get('content-type') || '';

  if (!response.ok) {
    if (contentType.includes('application/json')) {
      const payload = await response.json();
      throw new Error(payload.error || 'Download failed.');
    }

    throw new Error('Download failed.');
  }

  const blob = await response.blob();
  const filename = extractFilename(response.headers.get('content-disposition')) || fallbackFilename;
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl);
  }, 0);
}
